module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "entity-selector"
    }
  }, [_vm._v("Select entity")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedEntity),
      expression: "selectedEntity"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "entity-selector"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedEntity = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "call_email"
    }
  }, [_vm._v("Call / Email")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inspection"
    }
  }, [_vm._v("Inspection")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "offence"
    }
  }, [_vm._v("Offence")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sanction_outcome"
    }
  }, [_vm._v("Sanction Outcome")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "legal_case"
    }
  }, [_vm._v("Case")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    ref: "elemId",
    staticClass: "form-control no-label",
    attrs: {
      "id": _vm.elemId,
      "readonly": _vm.readonlyForm,
      "placeholder": "Begin typing to search"
    }
  })]), _vm._v(" "), (!_vm.readonlyForm) ? _c('div', {
    staticClass: "col-sm-3 no-label"
  }, [_c('a', {
    ref: "add_weak_link",
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": _vm.callCreateWeakLink
    }
  }, [_vm._v("Add")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('label', {
    attrs: {
      "for": "comment"
    }
  }, [_vm._v("Add comment")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    ref: "comment",
    staticClass: "form-control",
    attrs: {
      "id": "comment",
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c2cd538"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/weak_links.vue
// module id = 957
// module chunks = 0